import { useNavigateWithSearch } from "hooks/useNavigateWithSearch";
import AccordionTemplate from "components/accordions/accordion-template/AccordionTemplate";
import { pushGTMEvent } from "utils/gtmEvent";
import { GA_EVENT_CONFIGS } from "constants/gaEvents";
import { useContactInformation } from "hooks/useContactInformation";
import { ROUTES, CARD_FRAGMENTS } from "routes/constants";

const CoverageReplacementAccordion = () => {
    const navigate = useNavigateWithSearch();
    const { contactData } = useContactInformation();

    const coverageReplacementData = contactData?.coverageReplacement;

    const handleEdit = () => {
        pushGTMEvent(GA_EVENT_CONFIGS.REVIEW_EDIT_COVERAGE);
        navigate(`${ROUTES.APPLICATION.CONTACT}${CARD_FRAGMENTS.COVERAGE_REPLACEMENT}`);
    };

    return (
        <AccordionTemplate
            title="Coverage Replacement"
            accordionName="your-review-information"
            onEdit={handleEdit}
            dataTestId="coverage-replacement-accordion"
        >
            <div className="flex flex-col gap-2 mb-4">
                <p className="text-base-content text-sm font-semibold">
                    Is the insurance applied for intended to replace, discontinue, or change any existing insurance or annuity?
                </p>
                <p className="text-base-content text-sm font-bold">
                    {coverageReplacementData?.replacementIndicator ? "Yes" : "No"}
                </p>
            </div>
        </AccordionTemplate>
    );
};

export default CoverageReplacementAccordion;
